import Checklist from "./Checklist";

const { register } = require("@lpm/pug-components/dist/register");

register("Checklist/Checklist", Checklist);
